module.exports = __webpack_public_path__ + "static/img/limit_white_03.6cfe5fee.svg";